import React from 'react';
import styles from './styles/audio-player.module.scss';
import MarkdownParser from 'components/rich-text/markdown-parser';

interface IProps {
	id: string;
	isActive: boolean;
	title: string;
	handleTrackChange: (arg0: string) => unknown;
}

class PlaylistTrack extends React.PureComponent<IProps> {
	handleTrackChange() {
		this.props.handleTrackChange(this.props.id);
	}

	render() {
		return (
			<li
				className={`${styles.playlistTrack} ${this.props.isActive ? styles.isActive : ''}`}
			>
				<button
					onClick={this.handleTrackChange.bind(this)}
					title={this.props.title}
				>
					<div className={styles.playlistTrackTitle}>
						<MarkdownParser>{this.props.title}</MarkdownParser>
					</div>
				</button>
				{/* <!-- <div> track length goes here if we have it </div> --> */}
			</li>
		);
	}
}

export default PlaylistTrack;
